/**
 * Article → Diagnostic Tool routing map.
 *
 * When an article has an explicit `relatedTool` in its frontmatter, use it.
 * Otherwise, auto-detect by scanning the slug/title/keyword against these
 * patterns. First match wins. Returns null if no match.
 *
 * The 5 diagnostic tools:
 *  - nausea-fix         (slug: /glp-nausea-fix)
 *  - constipation-fix   (slug: /glp-constipation-fix)
 *  - energy-plateau     (slug: /glp-energy-plateau)
 *  - muscle-loss        (slug: /glp-muscle-loss)
 *  - plateau-detector   (slug: /glp-plateau-detector)
 */

// Ordered — more specific patterns first
const ROUTING_RULES = [
  // Nausea
  { toolKey: "nausea-fix", patterns: [/naus/i, /vomit/i, /queas/i, /morning-sick/i] },
  // Constipation
  { toolKey: "constipation-fix", patterns: [/constipat/i, /bowel/i, /\bBM\b/, /stool/i, /fiber/i, /bloat/i] },
  // Muscle loss / lean mass
  { toolKey: "muscle-loss", patterns: [/muscle/i, /lean-mass/i, /sarcope/i, /resistance-train/i, /protein/i, /strength/i] },
  // Energy plateau / fatigue
  { toolKey: "energy-plateau", patterns: [/fatigue/i, /tired/i, /energy/i, /brain-fog/i, /lethargy/i, /sleep/i] },
  // Weight plateau (generic — must come after muscle/energy to avoid false-matching "muscle plateau" etc)
  { toolKey: "plateau-detector", patterns: [/plateau/i, /stall/i, /stop-losing/i, /weight-loss-slow/i, /not-losing/i, /losing-slowly/i] },
];

/**
 * Given an article object, return the tool key or null.
 * Never overrides an explicit `relatedTool` — only fills in when absent.
 */
export function detectToolForArticle(article) {
  if (!article) return null;
  if (article.relatedTool) return article.relatedTool;
  const haystack = [
    article.slug || "",
    article.title || "",
    article.keyword || "",
    article.metaDescription || "",
  ].join(" ").toLowerCase();
  for (const rule of ROUTING_RULES) {
    if (rule.patterns.some((p) => p.test(haystack))) return rule.toolKey;
  }
  return null;
}
